import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { MaintenanceMixture, MaintenanceMixtureDraft } from '../../../recommendations/types';
import { useForBindingId } from '../../../forBinding';
import api from '../../http';
import { toApiError } from '../utils';

export interface CreateMixturePayload extends MaintenanceMixtureDraft {
	planId: string;
}

export function usePostAdviceMixture() {
	const queryClient = useQueryClient();
	const forBinding = useForBindingId();

	return useMutation<{ mixtures: MaintenanceMixture[] }, Error, CreateMixturePayload>({
		mutationFn: async (payload) => {
			try {
				const { data } = await api.post<{ mixtures: MaintenanceMixture[] }>(
					'/advices/fertilization-plan/mixtures/create',
					payload,
					{ params: { forBinding } }
				);
				return data;
			} catch (error) {
				throw toApiError(error, 'Erro ao inserir a mistura');
			}
		},
		onSettled: (_data, _error, variables) =>
			queryClient.invalidateQueries({ queryKey: ['maintenance', variables.planId] }),
	});
}
